import React from 'react';
import { withPlaceholders } from './Placeholder';
interface StepListProps {
  steps: string[];
}
export function StepList({
  steps
}: StepListProps) {
  return <ol className="space-y-4" data-id="element-147" data-mp="4u68oek29hv2">
      {steps.map((step, index) => <li key={step} className="flex gap-4" data-id="element-148" data-mp="it5yhpjb82st" data-mpi={index}>
          <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-white/10 bg-white/[0.06] font-mono text-xs font-semibold text-[#10b981]" data-id="element-149" data-mp="dsrnbymewcqk">
            {index + 1}
          </span>
          <p className="pt-0.5 text-[15.5px] leading-relaxed text-white sm:text-base" data-id="element-150" data-mp="nov0s0mprxst">
            {withPlaceholders(step)}
          </p>
        </li>)}
    </ol>;
}